import type { ReactNode } from 'react'

import type { Api } from '@subaio/utils'

import type { UserAuth } from 'lib/store'

import { Container } from './Container'
import { Footer } from './Footer'
import { Header } from './Header'
import { Main } from './Main'

type Props = {
	api: Api
	title: ReactNode
	children: ReactNode
	onLogout: () => void
	userAuth: UserAuth
	hideHeaderAndFooter?: boolean
}

export const Page = ({ api, children, onLogout, userAuth, hideHeaderAndFooter }: Props) => (
	<Container>
		{!hideHeaderAndFooter && <Header api={api} onLogout={onLogout} userAuth={userAuth} />}
		<Main>{children}</Main>
		{!hideHeaderAndFooter && <Footer />}
	</Container>
)
